import { Component, Prop } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { LocationDTO } from '../../../model/LocationDTO';

@Block() @Component
export class PageMetaLocationBlock extends BaseBlock {
	@Prop() location: LocationDTO;

	mounted() {
		const mainScript = this.getText('page-main-script');
		const scripts = this.getText('page-scripts').split(';');

		Promise.all(scripts.map(i => this.loadScript(i))).then(() => {
			const script = document.createElement('script');
			script.src = mainScript;
			document.head.appendChild(script);
		})
	}

	loadScript(src: string) {
		return new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.src = src.replace(/[\n\r]/g, '').trim();

			script.onload = () => resolve(script);
			script.onerror = () => reject(console.log(`Script load error for ${src}`));

			document.head.appendChild(script);
		}).then(() => console.log("Script loaded"));
	}

	get cityName(): string {
		var result = this.location.city;
		if (this.location.cityPart) {
			result += " - " + this.location.cityPart;
		}

		return result;
	}

	get titleText(): string {
		return this.getText('page-title', [
			this.cityName,
			this.location.name
		]);
	}

	get descriptionText(): string {
		return this.getText('page-description', [
			this.cityName,
			this.location.name
		]);
	}
}

export default PageMetaLocationBlock;
